export default [
  {
    path: '/online-checkin-share/:localizator',
    name: 'foravila-online-checkin',
    component: () => import('@/views/foravila/bookings/check-in/DettachedCheckin.vue'),
    meta: {
      layout: 'full',
      resource: 'Checkin'
    },
  },
]

// http://192.168.1.155:8081/online-checkin-share/23-49254937?key=50a28ee4-34c4-4e29-8da6-3911a2484983